// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app-layout[data-v-4b79031c]{width:90%;margin:20px auto;background-color:#fff;border:1.5px solid #d3d3d3;border-radius:5px;overflow:hidden}.divider-line[data-v-4b79031c]{height:1px;background-color:#d3d3d3}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
